// Copyright (c) 2020 Comsearch, Inc., All rights reserved

export const BandIdEnum = Object.freeze({
  E_BAND: 44,
})

export const AnalysisDisplayColorIdEnum = Object.freeze({
  UNSET: -1,
  NO_CASE_MARGIN: 0,
  NO_CASE_MARGIN_BUT_ONLY_WITH_OH_LOSS: 1,
  NO_CASE_MARGIN_EXCEPT_ON_GROWTH_CHANNELS: 2,
  CASE_MARGIN_NOT_MET: 3,
  CO_CHANNEL_BUCK_CO_POLARIZED: 4,
  CO_CHANNEL_BUCK_CROSS_POLARIZED: 5,
})

export const AnalysisStatusIdEnum = Object.freeze({
  WAITING: 1,
  RUNNING: 2,
  COMPLETED: 3,
  FAILED: 4,
  STALE: 5,
  AFS_FILTERING: 6,
  AFS_FILTERING_RUNNING: 7,
})

export const AnalysisTypeIdEnum = Object.freeze({
  ENVIRONMENT: 1,
  INTRASYSTEM: 2,
  EARTH_STATION: 3,
})

export const PathStatusIdEnum = Object.freeze({
  IN_PROGRESS: 1,
  FINALIZED: 2,
})

export const PcnStatusIdEnum = Object.freeze({
  NP: 1,
  NA: 2,
  CP: 3,
  CL: 4,
})

export const ProjectStatusIdEnum = Object.freeze({
  IN_PROGRESS: 1,
  PENDING: 2,
  FINALIZED: 3,
})

export const ProjectTypeIdEnum = Object.freeze({
  ENGINEERING: 1,
  EXTERNAL_PCN: 2,
  PROTECTION: 3,
})

export const RadioTypeIdEnum = Object.freeze({
  ANALOG: 1,
  DIGITAL: 2,
  REPEATER: 3,
})
